import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { FormBuilder, FormGroupDirective, NgForm, FormControl, Validators, FormGroup, AbstractControl, ValidationErrors, FormArray } from '@angular/forms';

@Component({
  selector: 'app-unverified-business',
  templateUrl: './unverified-business.component.html',
  styleUrls: ['./unverified-business.component.css']
})


export class UnverifiedBusinessComponent implements OnInit {

  constructor() {
  //  this.initForms();
  }

  ngOnInit() {   
  }
}
